import { createSlice } from "@reduxjs/toolkit";
import dayjs from "dayjs";
import JournalVoucher from "../Jv/JournalVoucher";
const initialStateValue = {
  showCheckReturnList: false,
  filterData: {
    branchValue: "",
    branchTouch: false,
    voucherDate: "",
    voucherDateTouch: false,
  },
  gridRows: [],
  gridPaginationData: {
    lastActivePage: 0,
  },
  data: {
    id: "",
    fileBranch: "",
    appNum: "",
    glAccount: "",
    debit: "",
    credit: "",
    applicationName: "",
    proposalType: "",
    glAccountDesp: "",
    naration: "",
  },
};
const JournalVoucherReducer = createSlice({
  name: "journalVoucher",
  initialState: initialStateValue,
  reducers: {
    updateGridRows(state, action) {
      state.gridRows = action.payload;
    },

    updateGridPaginationData(state, action) {
      state.gridPaginationData = action.payload;
    },
    resetGridRows(state, action) {
      state.gridRows = [];
      state.gridPaginationData.lastActivePage = 0;
    },
    resetFilterValues(state, action) {
      state.filterData.fileBranch = "";
      state.filterData.voucherDate = null;
    },
    updateBranchValue(state, action) {
      state.data.fileBranch = action.payload;
    },

    updateApplicationNum(state, action) {
      state.data.appNum = action.payload;
    },
    updateDebit(state, action) {
      state.data.debit = action.payload;
    },
    updateCredit(state, action) {
      state.data.credit = action.payload;
    },

    updateProposalType(state, action) {
      state.data.proposalType = action.payload;
    },
    updateGlAccountDesp(state, action) {
      state.data.glAccountDesp = action.payload;
    },
    updateApplicationName(state, action) {
      state.data.applicationName = action.payload;
    },
    updateGlAccount(state, action) {
      state.data.glAccount = action.payload;
    },
    updateNaration(state, action) {
      state.data.naration = action.payload;
    },
    updateGridRowCount(state, action) {
      state.data.id = action.payload;
    },
    updateValues(state, action) {
      state.data.id = action.payload.id;
      state.data.fileBranch = action.payload.fileBranch;
      state.data.appNum = action.payload.appNum;
      state.data.glAccount = action.payload.glAccount;
      state.data.debit = action.payload.debit;
      state.data.credit = action.payload.credit;
      state.data.applicationName = action.payload.applicationName;
      state.data.proposalType = action.payload.proposalType;
      state.data.glAccountDesp = action.payload.glAccountDesp;
      state.data.naration = action.payload.naration;
    },

    resetValues(state, action) {
      state.data.id = 0;
      state.data.fileBranch = "";
      state.data.appNum = "";
      state.data.glAccount = "";
      state.data.debit = "";
      state.data.credit = "";
      state.data.applicationName = "";
      state.data.proposalType = "";
      state.data.glAccountDesp = "";
      state.data.naration = "";
    },
  },
});
export const JournalVoucherReducerAction = JournalVoucherReducer.actions;
export default JournalVoucherReducer.reducer;
